<ion-reorder-group
  *ngIf="layout === 'list'; else grid"
  [disabled]="!reorderEnabled"
  (ionItemReorder)="onReorder($any($event))"
>
  <ng-container
    *ngFor="let item of items"
    [ngTemplateOutlet]="itemTemplate ?? null"
    [ngTemplateOutletContext]="{
      $implicit: item,
      reorderEnabled: reorderEnabled
    }"
  ></ng-container>
</ion-reorder-group>

<ng-template #grid>
  <div
    class="fl-reorder-grid"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp()"
    (pointercancel)="onPointerUp()"
  >
    <div
      *ngFor="let item of items; let i = index"
      class="fl-reorder-cell"
      [class.fl-reorder-cell--dragging]="draggingIndex === i"
      [class.fl-reorder-cell--target]="dropIndex === i && draggingIndex !== i"
      [attr.data-reorder-index]="i"
      (pointerdown)="onPointerDown($event, i)"
    >
      <ng-container
        [ngTemplateOutlet]="itemTemplate ?? null"
        [ngTemplateOutletContext]="{
          $implicit: item,
          reorderEnabled: reorderEnabled
        }"
      ></ng-container>
    </div>
  </div>
</ng-template>
